import Autocomplete from '@material-ui/lab/Autocomplete';
import styled from 'styled-components';

export const StyledAutoComplete = styled(Autocomplete)`
  input {
    padding: 12px !important;
  }
  .MuiAutocomplete-inputRoot {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .MuiInputLabel-outlined {
    transform: translate(14px, 12px) scale(1);
  }
`;
